import React from 'react';
import logo from '../../images/logo_only.svg';
import './Spinner.css';

// dark: white-on-black variant used by the shared game page
export default function PuttrSpinner({ dark, title = 'LINING IT UP...' }) {

  return(

    <div style={{display: 'grid', placeItems: 'center', height: '100vh', width:'100%', backgroundColor: dark ? '#000' : 'transparent'}}>

      <div style={{textAlign:'center'}}>

        <img src={logo} className="App-logo" alt="logo" style={dark ? { filter: 'invert(1)', opacity: 0.25 } : undefined} />

        <div className="label" style={dark ? { color: 'rgba(255,255,255,0.35)', fontSize: 11, letterSpacing: 1.5, marginTop: 10 } : undefined}>{title}</div>

      </div>

    </div>

  );
}
